import { render, staticRenderFns } from "./CrewImportModal.vue?vue&type=template&id=4e354e73&scoped=true&"
import script from "./CrewImportModal.vue?vue&type=script&lang=js&"
export * from "./CrewImportModal.vue?vue&type=script&lang=js&"
import style0 from "./CrewImportModal.vue?vue&type=style&index=0&id=4e354e73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e354e73",
  null
  
)

export default component.exports